module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-argil-005-1200x2490.7f9cac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-argil-005-1200x2490.jpg
// module id = 1086
// module chunks = 37